import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateShift($companyId: ID!, $attributes: ShiftAttributes!) {
    createShift(companyId: $companyId, attributes: $attributes) {
      shift {
        id
        ...CreatedShift
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedShift on Shift {
    id
    user { id displayName }
    start
    finish
    rateCents
    shiftRole { id name }
  }
`
